import { render, staticRenderFns } from "./Calculations.vue?vue&type=template&id=1968c4f0&"
import script from "./Calculations.vue?vue&type=script&lang=js&"
export * from "./Calculations.vue?vue&type=script&lang=js&"
import style0 from "./Calculations.vue?vue&type=style&index=0&id=1968c4f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports